export class Authority {
    public name?: string;

    constructor(name?: string) {
        this.name = name ? name : null;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/user/authority.model.ts